import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    add: -1,
    loadList: -1,
    loadLast: -1,
    loadDetails: -1,
  },
  list: [],
  last: {},
  details: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.EMR_VISIT_ADD_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          add: 0,
        },
      };
    case ACTION_TYPES.EMR_VISIT_ADD_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          add: 1,
        },
        details: payload,
      };
    case ACTION_TYPES.EMR_VISIT_ADD_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          add: 2,
        },
        error,
      };

    case ACTION_TYPES.EMR_VISITS_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 0,
        },
      };
    case ACTION_TYPES.EMR_VISITS_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 1,
        },
        list: payload,
      };
    case ACTION_TYPES.EMR_VISITS_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 2,
        },
        error,
      };

    case ACTION_TYPES.EMR_VISITS_LAST_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadLast: 0,
        },
      };
    case ACTION_TYPES.EMR_VISITS_LAST_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadLast: 1,
        },
        last: payload,
      };
    case ACTION_TYPES.EMR_VISITS_LAST_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadLast: 2,
        },
        error,
      };

    case ACTION_TYPES.EMR_VISIT_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDetails: 0,
        },
      };
    case ACTION_TYPES.EMR_VISIT_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDetails: 1,
        },
        details: payload,
      };
    case ACTION_TYPES.EMR_VISIT_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDetails: 2,
        },
        error,
      };

    case ACTION_TYPES.EMR_VISITS_RESET_STATUS:
      return {
        ...state,
        status: initialState.status,
      };

    default:
      return state;
  }
}
